var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C7.5625 5 4 8.59375 4 13C4 17.4375 7.5625 21 12 21C16.4062 21 20 17.4375 20 13C20 8.59375 16.4062 5 12 5ZM12 19.5C8.40625 19.5 5.5 16.5938 5.5 13C5.5 9.4375 8.40625 6.5 12 6.5C15.5625 6.5 18.5 9.4375 18.5 13C18.5 16.5938 15.5625 19.5 12 19.5ZM12 15.5C11.4375 15.5 11 15.9375 11 16.5C11 17.0625 11.4062 17.5 12 17.5C12.5312 17.5 13 17.0625 13 16.5C13 15.9375 12.5312 15.5 12 15.5ZM13.0312 9H11.4375C10.2188 9 9.25 9.96875 9.25 11.1875C9.25 11.5938 9.59375 11.9375 10 11.9375C10.4062 11.9375 10.75 11.5938 10.75 11.1875C10.75 10.8125 11.0312 10.5 11.4062 10.5H13C13.4062 10.5 13.75 10.8125 13.75 11.1875C13.75 11.4375 13.625 11.6562 13.4062 11.7812L11.625 12.8438C11.375 13 11.25 13.25 11.25 13.5V14C11.25 14.4062 11.5938 14.75 12 14.75C12.4062 14.75 12.75 14.4062 12.75 14V13.9375L14.1562 13.0625C14.8125 12.6562 15.2188 11.9375 15.2188 11.1875C15.25 9.96875 14.2812 9 13.0312 9Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.5db4f9286205f67f9b889281372f1917.svg";
export { ForwardRef as ReactComponent };